module.exports = __webpack_public_path__ + "static/media/fight.853a92ef.gif";